/** @file The viewport's whole binding table: its own chords plus every tool's activation chord. */
import type { Binding } from '@pose2d/shortcuts/types';
import type { ToolDef } from '../../stores/types';
import { TOOLS } from '../../tools.gen';
import { bindings } from './bindings';

/** The same objects as bindings.ts and the ToolDefs, so allBindings deduplicates by identity. */
export function viewportTable(): Binding[] {
  const tools: readonly ToolDef[] = TOOLS;
  return [...bindings, ...tools.flatMap((t) => t.bindings)];
}
